import HeroBg from "public/colocation/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Check Our Pricing",
    link: "colocation",
  },
  button2: {
    label: "Secure Your Infrastructure Today",
    link: "contact-us",
  },
  desc: "Host your infrastructure in highly secure, redundant data centers with 24/7 monitoring, optimal cooling, and seamless scalability.",
  title: "Secure, Reliable, and Scalable Colocation Services",
  image: HeroBg,
};
